import React, { PureComponent, PropTypes } from 'react';

export default class UserWatchList extends PureComponent {
  static displayName = 'UserWatchList';

  static propTypes = {
    /**
     * A list of watch list groupings
     */
    children: PropTypes.node
  };

  render() {
    return <div>{this.props.children}</div>;
  }
}



// WEBPACK FOOTER //
// ./js/UserWatchList/UserWatchList.js